import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import {
  transformManifestRequestBody,
  transformManifestResponse,
} from "./transformers";
import { Manifest, ManifestPartial } from "./types";

export const useUpdateManifest = (id: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<Manifest>, Error, ManifestPartial>({
    mutationKey: ["updateManifest"],
    mutationFn: async (data) =>
      transformManifestResponse(
        await dispatch(
          apiThatThrows.updateAppManifest.action({
            params: { id },
            options: {
              body: JSON.stringify(transformManifestRequestBody(data)),
            },
          })
        )
      ),
    onSuccess(data) {
      queryClient.setQueryData(
        ["manifest", { id: data.results.id }],
        () => data
      );
    },
  });
};
